module.exports = __webpack_public_path__ + "img/dg.150879d0.png";